export const TOOLTIP_DEFAULT_DELAY = 200;
